import React from 'react'

/**
 * The expanded log.
 *
 * Not `requestFullscreen`: that hands the viewport to a bare <div> and buys the
 * browser's own "Press Esc to exit full screen" overlay with it — a message
 * nothing in this codebase can dismiss, sitting over the first lines you came
 * to read. This is our own layer, so the exit control can be where you look for
 * it and Escape can close it quietly.
 *
 * The bar is fixed at the top and the log scrolls under it. The old control was
 * `sticky top-[calc(100%-25px)] left-full` — pinned to the bottom-right corner
 * of a scrolling box, which is neither where a close button lives nor a place
 * you find it while reading.
 */
const LogOverlay = ({ label, onClose, children }: {
  /** What is being shown — "build log", "container output". */
  label: string,
  onClose: () => void,
  children: React.ReactNode,
}) => (
  <div className="fixed inset-0 z-[9999] bg-navy-950 flex flex-col">
    <div className="flex-none flex items-center justify-between gap-3 px-4 py-2.5 bg-navy-900 border-b border-navy-700">
      <span className="font-courrier text-ds-115 text-navy-300 truncate">{label}</span>
      <button
        type="button"
        onClick={onClose}
        className="b4-focus flex-none inline-flex items-center h-[30px] px-3 rounded-control border border-navy-400 bg-navy-700 text-ds-125 font-semibold text-navy-100 hover:bg-navy-600 transition-colors duration-[120ms]"
      >
        Exit
      </button>
    </div>
    <div className="flex-1 min-h-0 overflow-y-auto b4-thin py-1.5">
      {children}
    </div>
  </div>
)

export default LogOverlay
